<template>
  <div class="company-card__hint-inner">
    <div class="company-card__hint-icon">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="9" cy="9" r="9" fill="#FC8E51" />
        <path
          d="M9.01922 14.3992C8.75287 14.3992 8.52089 14.3028 8.32328 14.11C8.12566 13.9081 8.02686 13.6694 8.02686 13.394C8.02686 13.1094 8.12137 12.8662 8.31039 12.6642C8.508 12.4623 8.73998 12.3613 9.00633 12.3613C9.28127 12.3613 9.51755 12.4623 9.71516 12.6642C9.91277 12.857 10.0116 13.0957 10.0116 13.3802C10.0116 13.6556 9.91277 13.8943 9.71516 14.0962C9.52614 14.2982 9.29416 14.3992 9.01922 14.3992Z"
          fill="white"
        />
        <path d="M8 4.5H10V11.5H8V4.5Z" fill="white" />
      </svg>
    </div>
    <div class="company-card__hint-text">
      <!--      {{ $t("company_card.hint.hold") }}-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyCardHintWaitInformation',
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
.company-card {
  &__hint {
    &-icon {
      background-color: #fff0d2;
    }

    &-text {
      display: flex;
      align-items: center;
      background-color: #fff0d2;
      border-radius: 15px;
      padding: 15px 27px;
    }
  }
}
</style>
